import { Star } from "lucide-react";
import { Reveal, Overline } from "@/components/primitives";
import { assets } from "@/config/assets";

const TESTIMONIALS = [
  {
    quote: "We went from asking for reviews and forgetting, to a steady flow every single week — without lifting a finger.",
    name: "Café owner",
    role: "Coffee shop · Single location",
    image: assets.lifestyle.coffeeOwner,
  },
  {
    quote: "The AI replies sound like us, and our Google profile finally looks active. New clients say they found us online.",
    name: "Salon founder",
    role: "Beauty salon · Multi location",
    image: assets.lifestyle.salon,
  },
  {
    quote: "Our reviews now turn into social posts automatically. It's the marketing help we could never afford to hire.",
    name: "Studio owner",
    role: "Fitness studio · Single location",
    image: assets.lifestyle.gym,
  },
];

export default function Testimonials() {
  return (
    <section className="bg-base py-24 lg:py-32">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-3xl">
            <Reveal><Overline>Social proof</Overline></Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-6 text-4xl font-black leading-[1.02] tracking-tighter text-black sm:text-5xl lg:text-6xl">
                Trusted by modern local businesses
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <span className="rounded-[10px] border border-black/15 px-3 py-1.5 text-[11px] font-medium uppercase tracking-[0.14em] text-black/45">
              Illustrative placeholders
            </span>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <figure className="flex h-full flex-col overflow-hidden rounded-[10px] border border-black/10 bg-white">
                <div className="overflow-hidden">
                  <img src={t.image} alt="" className="h-44 w-full object-cover grayscale transition-[filter,transform] duration-500 hover:scale-105 hover:grayscale-0" />
                </div>
                <div className="flex flex-1 flex-col p-7">
                  <div className="flex gap-0.5">
                    {Array.from({ length: 5 }).map((_, s) => (
                      <Star key={s} size={14} className="fill-black text-black" />
                    ))}
                  </div>
                  <blockquote className="mt-4 flex-1 text-base font-light leading-relaxed text-black/80">
                    "{t.quote}"
                  </blockquote>
                  <figcaption className="mt-6 border-t border-black/[0.08] pt-4">
                    <div className="text-sm font-semibold text-black">{t.name}</div>
                    <div className="text-xs font-light text-black/45">{t.role}</div>
                  </figcaption>
                </div>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
